const sizes = {
  container: {
    xs: '480px',
  },
};

export default sizes;
